export default __webpack_public_path__ + "static/media/arrowdone.1f46c984.svg";